import styled, { createGlobalStyle, css, keyframes } from 'styled-components';
import theme from 'lib/theme';

const aniText = keyframes`

  from {
    background-position: 0 0;
  }
  to {
    background-position: -200% 0;
  }
`;

export const StyledNickname = styled.span`
  &.mt-nickname-star-vip {
    background-image: -webkit-linear-gradient(
      left,
      #f70000,
      #ff891c 14.3%,
      #ffe719 28.6%,
      #33e97c 43%,
      #1dd5ff 57%,
      #ec80ff 71.4%,
      #ff43dc 86%,
      #ff43cb 100%
    );
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-background-size: 200% 100%;
    -webkit-animation: ${aniText} 3s infinite linear;
  }
`;

export const IconAndroid = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background: url(${require('./images/icon-android.png')}) no-repeat center
    center / contain;
`;

export const IconIos = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background: url(${require('./images/icon-ios.png')}) no-repeat center center /
    contain;
`;

export const IconYouqu = styled.span`
  display: inline-block;
  vertical-align: middle;
  height: 26px;
  width: 18px;
  background: url(${require('./images/icon-youqu.png')}) 0 0 / contain no-repeat;
  transform: scale(0.9);
`;
